import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo/Dira-Holidays-Logo_navigation.png';
import useScrollNav from '../hooks/useScrollNav';
import { Icon } from './Icons';

const PAGES = ['holidays', 'destinations', 'corporate', 'experiences', 'about'];
const PAGE_LABELS = {
  home: 'Home',
  holidays: 'Holidays',
  destinations: 'Destinations',
  corporate: 'Corporate',
  experiences: 'Experiences',
  about: 'About'
};

export default function Navbar({ activePage }) {
  const navigate = useNavigate();
  const scrolled = useScrollNav(60);
  const [menuOpen, setMenuOpen] = useState(false);

  const isHome = activePage === 'home';
  const isWhiteNav = scrolled || !isHome;

  const navBg = isWhiteNav ? 'transparent' : 'transparent';
  const navShadow = isWhiteNav ? '0 1px 0 #e2e8f0' : 'none';
  const linkColor = isWhiteNav ? '#3d4a5c' : 'var(--ink)';

  // Button dynamic styles
  // const loginBg = isWhiteNav ? 'var(--brand)' : 'var(--brand)';
  // const loginColor = isWhiteNav ? '#ffffff' : '#ffffff';
  // const loginBorder = isWhiteNav ? 'var(--brand)' : 'var(--brand)';

  // const planBtnBg = isWhiteNav ? 'var(--secondary)' : 'var(--brand)';
  // const planBtnColor = isWhiteNav ? '#0d1117' : '#ffffff';
  // const planBtnBorder = isWhiteNav ? 'var(--secondary)' : 'var(--brand)';

  return (
    <nav style={{ position: 'sticky', top: 0, zIndex: 1000 }}>
      {/* Top ribbon */}
      <div
        style={{
          background: 'var(--brand)',
          padding: '7px 32px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '6px',
        }}
      >
        <div style={{ display: 'flex', gap: '20px', alignItems: 'center', flexWrap: 'wrap' }}>
          <span
            style={{
              fontSize: '11px',
              fontWeight: 600,
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
            }}
          >
            <Icon name="phone" size={12} color="#fff" /> +91 7094606002
          </span>
          <a
            href="https://wa.me/917094606002"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontSize: '11px',
              fontWeight: 600,
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              textDecoration: 'none'
            }}
          >
            <Icon name="whatsapp" size={12} color="#fff" /> +91 70922 10922
          </a>
        </div>
        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <span style={{ fontSize: '11px', fontWeight: 700, color: '#fff' }}>
            🇮🇳 India's #1 Travel Brand
          </span>
          <span
            style={{
              fontSize: '10px',
              fontWeight: 700,
              background: '#0d1117',
              color: '#fff',
              padding: '2px 10px',
              borderRadius: '4px',
              letterSpacing: '.5px',
            }}
          >
            IATA CERTIFIED
          </span>
        </div>
      </div>

      {/* Main bar */}
      <div
        className={`nav-main ${isWhiteNav ? 'white' : 'transparent'}`}
        style={{
          background: navBg,
          boxShadow: navShadow,
          backdropFilter: 'blur(16px)',
          WebkitBackdropFilter: 'blur(16px)',
          padding: '0 32px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '62px',
          transition: 'background 0.3s, box-shadow 0.3s',
        }}
      >
        {/* Logo */}
        {/* <button onClick={() => navigate('/')} style={{ display: 'flex', alignItems: 'center', gap: '10px', background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
          <div style={{ width: '36px', height: '36px', background: '#69e382', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', fontWeight: 800, color: '#0d1117', flexShrink: 0 }}>M</div>
          <div style={{ textAlign: 'left' }}>
            <div style={{ fontSize: '18px', fontWeight: 800, color: logoColor, letterSpacing: '2px', lineHeight: 1, transition: 'color 0.3s' }}>DIRA HOLIDAYS</div>
            <div style={{ fontSize: '7px', fontWeight: 700, letterSpacing: '3.5px', color: '#69e382', lineHeight: 1 }}>HOLIDAYS</div>
          </div>
        </button> */}

        <button
          onClick={() => navigate('/')}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
          }}
        >
          <img
            src={logo}
            alt="logo"
            style={{
              width: 'auto',
              height: '50px',
              borderRadius: '10px',
              // objectFit: 'cover',
              flexShrink: 0,
            }}
          />
        </button>

        {/* Nav links (Desktop) */}
        <div className="nav-links-desktop" style={{ display: 'flex', gap: '2px' }}>
          {PAGES.map((pg) => (
            <button
              key={pg}
              onClick={() => navigate(pg === 'home' ? '/' : `/${pg}`)}
              className={`nav-link ${activePage === pg ? 'active' : ''}`}
              style={{
                color: activePage === pg ? 'var(--brand)' : linkColor,
                transition: 'all 0.3s',
              }}
            >
              {PAGE_LABELS[pg]}
            </button>
          ))}
        </div>

        {/* Hamburger Toggle (Mobile Only) */}
        <button
          className="nav-hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation menu"
          style={{
            background: 'none',
            border: 'none',
            color: isWhiteNav ? 'var(--ink)' : 'var(--ink)',
            cursor: 'pointer',
            padding: '8px',
            display: 'none', // Overridden in CSS for screens < 768px
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            {menuOpen ? (
              <>
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </>
            ) : (
              <>
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </>
            )}
          </svg>
        </button>

        {/* CTA buttons */}
        <div style={{ display: 'flex', gap: '10px' }}>
          {/* <button
            style={{
              padding: '9px 18px',
              background: loginBg,
              border: `2px solid ${loginBorder}`,
              color: loginColor,
              borderRadius: '8px',
              fontSize: '12px',
              fontWeight: 700,
            }}
          >
            Login
          </button>
          <button
            style={{
              padding: '9px 18px',
              background: planBtnBg,
              border: `2px solid ${planBtnBorder}`,
              color: planBtnColor,
              borderRadius: '8px',
              fontSize: '12px',
              fontWeight: 800,
            }}
          >
            Plan a Trip
          </button> */}
        </div>
      </div>

      {/* Mobile drawer links (Mobile Only) */}
      <div className={`nav-links-mobile ${menuOpen ? 'open' : ''}`} style={{
        background: '#ffffff',
        borderBottom: '1px solid #e2e8f0',
        display: 'none', // Overridden in CSS for screens < 768px
        flexDirection: 'column',
        position: 'absolute',
        width: '100%',
        left: 0,
        zIndex: 999,
        boxShadow: '0 8px 24px rgba(0,0,0,0.1)'
      }}>
        {PAGES.map((pg) => (
          <button
            key={pg}
            onClick={() => {
              navigate(pg === 'home' ? '/' : `/${pg}`);
              setMenuOpen(false);
            }}
            className={`mobile-nav-link ${activePage === pg ? 'active' : ''}`}
            style={{
              padding: '14px 32px',
              width: '100%',
              textAlign: 'left',
              background: activePage === pg ? 'var(--brand-lt)' : 'none',
              border: 'none',
              borderLeft: activePage === pg ? '4px solid var(--brand)' : '4px solid transparent',
              fontSize: '14px',
              fontWeight: 700,
              color: activePage === pg ? 'var(--brand)' : 'var(--stone)',
              cursor: 'pointer'
            }}
          >
            {PAGE_LABELS[pg]}
          </button>
        ))}
      </div>
    </nav>
  )
}
